import { useRef } from 'react';

import { SpotTradeAPI } from '@api/spotTrade'
import useAuthSession from '@lib/hooks/useAuthSession'
import { useIsomorphicLayoutEffect } from '@lib/hooks/useIsomorphicLayoutEffect'
import pubsub from '@lib/scripts/pubsub'

export const useMarginBalance = ({ base, quote }) => {
  // const [data, setData] = useState(null);
  const marginBalanceRef = useRef({});
  const isLogin = useAuthSession({ redirectTo: null })
  const fetchMarginBalance = async () => {
    if (!isLogin) {
      return
    }
    const [
      { value: buyMarginBalance },
      { value: sellMarginBalance }
    ] = await Promise.allSettled([
      SpotTradeAPI.marginBalance({ base, quote, side: 'buy' }),
      SpotTradeAPI.marginBalance({ base, quote, side: 'sell' })
    ]);
    if (buyMarginBalance?.success) {
      marginBalanceRef.current.buy = buyMarginBalance.obj
    }
    if (sellMarginBalance?.success) {
      marginBalanceRef.current.sell = sellMarginBalance.obj
    }
  }

  const updateMarginBalance = async ({ symbol }) => {
    if (symbol === `${base}_${quote}`) {
      fetchMarginBalance()
    }
  }

  useIsomorphicLayoutEffect(() => {
    if (isLogin && base && quote) {
      pubsub.subscribe(['CANCEL_TRADE_ORDER', 'TRADER_ENTRUST_DATA_CHANGE'], updateMarginBalance);
      return () => {
        pubsub.unSubscribe(['CANCEL_TRADE_ORDER', 'TRADER_ENTRUST_DATA_CHANGE'], updateMarginBalance);
      }
    }
  }, [isLogin, base, quote])

  useIsomorphicLayoutEffect(() => {
    if (isLogin && base && quote) {
      fetchMarginBalance()
    }
  }, [isLogin, base, quote])

  return { marginBalanceRef, fetchMarginBalance }
}
